import React, { useState } from 'react';
import { getKeywordsFromAI } from '../../api/aiKeywordsApi';
import { sendAIQuery } from '../../api/aiApi';
import styles from './AIViewMain.module.css';
import ReactMarkdown from 'react-markdown';

const AIViewMain = () => {
  const [content, setContent] = useState({ note: '', tags: '' });
   const [isEditing, setIsEditing] = useState(false);
  const [aiInput, setAIInput] = useState('');
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tokenUsage, setTokenUsage] = useState(0);
  const [processingTime, setProcessingTime] = useState(0);

  const handleAISubmit = async () => {
    if (!aiInput.trim()) return;
    setLoading(true);
    setContent({ note: "" });
  
    const url = "http://172.234.197.110:8000/api/ai-query"; // Ensure it's hitting the right port
    

    console.log("Calling API:", url);
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { 
            "Content-Type": "application/json"
        },
        credentials: "include",  // ✅ Ensures cookies are sent automatically
        body: JSON.stringify({ input_text: aiInput })
    });
  
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }
  
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedText = "";
  
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
  
        const chunk = decoder.decode(value);
        const lines = chunk.split("\n");
  
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            try {
              const data = JSON.parse(line.slice(6));
              accumulatedText += data.content || "";

              await new Promise(resolve => setTimeout(resolve, 25)); // Delay 100ms per update
  
              setContent((prev) => ({
                ...prev,
                note: accumulatedText,
              }));
  
              if (data.token_usage) setTokenUsage(data.token_usage);
              if (data.processing_time_seconds)
                setProcessingTime(data.processing_time_seconds);
            } catch (e) {
              console.error("Error parsing SSE data:", e);
            }
          }
        }
      }
    } catch (error) {
      console.error("API Error:", error);
      setContent((prev) => ({
        ...prev,
        note: "Error: Could not fetch AI response",
      }));
    } finally {
      setLoading(false);
    }
  };
  

  const handleExtractKeywords = async () => {
    try {
      const extracted = await getKeywordsFromAI(content.note);
      setKeywords(extracted?.pairs || []);
    } catch (error) {
      console.error("Failed to extract keywords:", error);
      setKeywords([]);
    }
  };

  return (
    <div className={styles.aiViewMain}>
      <div className={styles.header}>
        <input
          type="text"
          value={aiInput}
          onChange={(e) => setAIInput(e.target.value)}
          className={styles.titleInput}
          placeholder="Ask AI anything..."
        />
        <button 
          onClick={handleAISubmit}
          className={styles.submitButton}
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Submit Query'}
        </button>
      </div>

      <div className={styles.tokenDisplay}>
      Tokens used: {tokenUsage} | Time: {processingTime}s
      </div>

       <div className={styles.contentSection}>
				  {/* If in edit mode, show a textarea */}
				  {isEditing ? (
					<textarea
					  value={content.note}
					  onChange={(e) => setContent({ ...content, note: e.target.value })}
					  className={styles.responseArea}
					  placeholder="Edit AI response..."
					  onBlur={() => setIsEditing(false)} // Exit edit mode when losing focus
					  onKeyDown={(e) => e.key === 'Enter' && setIsEditing(false)} // Exit when pressing Enter
					  autoFocus
					/>
				  ) : (
					/* Otherwise, show Markdown preview */
					<div 
					  className={styles.responseArea} 
					  onClick={() => setIsEditing(true)} // Click to enter edit mode
					>
					  <ReactMarkdown>
						{content.note || "Click here to edit AI response..."}
					  </ReactMarkdown>
					</div>
				  )}
				</div>

      <div className={styles.actionBar}>
        <button 
          onClick={handleExtractKeywords}
          className={styles.extractButton}
        >
          Extract Keywords
        </button>
      </div>

      {keywords.length > 0 && (
        <div className={styles.keywordsSection}>
          <h3>Extracted Keywords:</h3>
          <div className={styles.keywordsList}>
            {keywords.map((pair, index) => (
              <div key={index} className={styles.keywordPair}>
                <strong>{pair[0]}</strong>: {pair[1]}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AIViewMain;